import PubSub from "underpub-js";

var MiniMap = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-MiniMap',
		settings: {
			style: 'mapbox://styles/authenticff/cm8x36qy700me01skaqtlh9pj',
			center: [-96, 40],
			zoom: 12,
		},
		colors: {
			markerBackground: '#000000',
		}
	};

	$.extend(true, this.options, options);

};

MiniMap.prototype.init = function() {
	var self = this;

	let computedElementStyle = getComputedStyle(self.options.$el.get(0));
	self.options.colors.markerBackground = computedElementStyle.getPropertyValue('--marker-background-color');

	self.$map = self.options.$el.find(`.${self.options.baseClass}__map`);
	self.$mapWrapper = self.options.$el.find(`.${self.options.baseClass}__mapWrapper`);
	self.lng = self.$mapWrapper.data('lng');
	self.lat = self.$mapWrapper.data('lat');
	self.options.settings.center = [self.lng, self.lat];
	const zoom = self.$mapWrapper.data('zoom');
	if (zoom) {
		self.options.settings.zoom = zoom;
	}
	self.initMap();

};

MiniMap.prototype.initMap = function() {
	const self = this;

	if (!self.lng || !self.lat) {
		console.error('Latitude and Longitude are required for element MiniMap.');
		return;
	}

	mapboxgl.accessToken =
		'pk.eyJ1IjoiYXV0aGVudGljZmYiLCJhIjoiUmtjWTY2byJ9.QeHZuWdaMRJlobq_RgXngw';

	self.map = new mapboxgl.Map({
		container: self.$map.get(0),
		style: self.options.settings.style,
		zoom: self.options.settings.zoom,
		center: self.options.settings.center,
	});
	// Create a custom blue circle marker
	const blueCircle = document.createElement('div');
	blueCircle.style.width = '20px';
	blueCircle.style.height = '20px';
	blueCircle.style.backgroundColor = self.options.colors.markerBackground;
	blueCircle.style.borderRadius = '50%'; // Makes it a circle
	blueCircle.style.boxShadow = '0 0 5px rgba(0, 0, 255, 0.5)';
	new mapboxgl.Marker(blueCircle)
		.setLngLat([self.lng, self.lat])
		.addTo(self.map);
}

export default MiniMap;
